import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { API, formatApiError } from "@/lib/api";

export default function CrmActivation() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords must match."); return; }
    setBusy(true); setError("");
    try {
      const response = await fetch(`${API}/crm/activate`, { method: "POST", credentials: "omit", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, password }) });
      const data = await response.json();
      if (!response.ok) throw new Error(formatApiError(data.detail));
      setDone(true);
      window.history.replaceState(null, "", window.location.pathname);
    }
    catch (err) { setError(err.message || "Could not activate access."); }
    finally { setBusy(false); }
  };
  return <main className="min-h-screen bg-[#EAF0F6] grid place-items-center p-5">
    <section className="w-full max-w-md rounded-xl bg-white border p-7 space-y-5">
      <h1 className="text-2xl font-bold text-[#17324D]">Set up your CRM login</h1>
      <p className="text-sm text-stone-600">Alaine &amp; Co. · Clients &amp; Pipeline only. This does not grant access to formulas or administrator settings.</p>
      {done ? <div><p>Your password is set.</p><Link className="underline text-[#17324D]" to="/login?next=clients">Sign in to the CRM</Link></div> :
        !token ? <p role="alert">This invitation link is incomplete. Ask your administrator for a new link.</p> :
        <form onSubmit={submit} className="space-y-4">
          <label className="block text-sm">New password (at least 12 characters)<input className="mt-1 block w-full rounded border p-2" type="password" autoComplete="new-password" required minLength={12} maxLength={72} value={password} onChange={e => setPassword(e.target.value)} /></label>
          <label className="block text-sm">Confirm password<input className="mt-1 block w-full rounded border p-2" type="password" autoComplete="new-password" required value={confirm} onChange={e => setConfirm(e.target.value)} /></label>
          {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
          <button disabled={busy} className="rounded bg-[#17324D] text-white px-4 py-2">{busy ? "Saving…" : "Set password"}</button>
        </form>}
    </section>
  </main>;
}
